import mapboxgl from "mapbox-gl";
import * as THREE from "three";
import {
  threeLineFragShader,
  threeLineVertShader
} from "../shaders/threeGeomShader.js";
import {getScalingFactor} from "../helpers.js";
import Stats from "three/addons/libs/stats.module.js";


let centerLatLng;
let myLine;
let statsPanels;
let goingUp = true;
let lineLength = 0;

let camera;
let myMap;
let renderer;
let scene;
let plateCreated = false;

const anchor = [0, 0];
const plateSize = 1_000_000;
const earthRadius = 1303.797293808806;

const coords = [];
const numPoints = 1000;
const numRotations = 50;
const scale = 10;
const angleIncrement = (Math.PI * 2 * numRotations) / numPoints;

for (let i = 0; i < numPoints; i++) {
  const angle = i * angleIncrement;
  const radius = scale * (i / numPoints);

  const x = radius * Math.cos(angle);
  const y = radius * Math.sin(angle);

  coords.push([x, y]);
}

export const threeLineLayer = {
  id: 'three-line-layer',
  type: 'custom',
  onAdd: (map, gl) => {
    console.log("hello!!!!!")
    const stats1 = new Stats();
    stats1.showPanel(0);
    document.body.appendChild(stats1.dom);

    const stats2 = new Stats();
    stats2.showPanel(1);
    stats2.dom.style.left = '80px';
    document.body.appendChild(stats2.dom);

    const stats3 = new Stats();
    stats3.showPanel(2);
    stats3.dom.style.left = '160px';
    document.body.appendChild(stats3.dom);
    statsPanels = [stats1, stats2, stats3];

    camera = new THREE.Camera();
    scene = new THREE.Scene();

    myMap = window.map = map;

    // const material = new THREE.LineBasicMaterial({ color: 0x0000ff, linewidth: 5 });
    const points = coords.map(coord => {
      const merc = mapboxgl.MercatorCoordinate.fromLngLat(coord, 100);
      return {x: merc.x, y: merc.y, z: merc.z}
    });


    centerLatLng = coords.reduce(
      (acc, coord) => [acc[0] + coord[0], acc[1] + coord[1]],
      [0, 0]
    ).map(val => val / coords.length);

    const material = new THREE.ShaderMaterial({
      uniforms: {
        'u_matrix': {value: new THREE.Matrix4()},
        'u_matrix_globe_merc': {value: new THREE.Matrix4()},
        'u_matrix_model': {value: new THREE.Matrix4()},

        'u_plate_tl_up': {value: new THREE.Vector3()},
        'u_plate_tr_up': {value: new THREE.Vector3()},
        'u_plate_br_up': {value: new THREE.Vector3()},
        'u_plate_bl_up': {value: new THREE.Vector3()},
        'u_plate_tl': {value: new THREE.Vector3()},
        'u_plate_tr': {value: new THREE.Vector3()},
        'u_plate_br': {value: new THREE.Vector3()},
        'u_plate_bl': {value: new THREE.Vector3()},

        'u_plate_height': {value: 0},
        'u_plate_width': {value: 0},
        'u_plate_up_scale': {value: 0},
        'u_zoom_transition': {value: 0},
        'u_centerInMerc': {value: new THREE.Vector2()},
        'u_pixelsPerMeterRatio': {value: 0},

        'u_scale_factor': {value: 0},
        // 'u_lat': {value: x},
        // 'u_lon': {value: y},


      }, vertexShader: threeLineVertShader, fragmentShader: threeLineFragShader,
      side: THREE.DoubleSide,
      depthTest: false,
    });

    const geometry = new THREE.BufferGeometry().setFromPoints( points );
    const line = new THREE.Line( geometry, material );
    scene.add( line );

    myLine = line;

    renderer = new THREE.WebGLRenderer({
      canvas: map.getCanvas(), context: gl, antialias: true,
    });

    renderer.autoClear = false;

    renderer.render(scene, camera);
  },

    render(gl, projectionMatrix, projection, globeToMercMatrix, transition, centerInMercator, pixelsPerMeterRatio) {
      statsPanels.forEach(stats => stats.begin());
      if (myLine?.material) {
        const u = myLine.material.uniforms;

        if (goingUp) {
          if (lineLength === 1000) {
            goingUp = false
          } else {
            lineLength ++;
          }
        } else {

          if (lineLength === 0) {
            goingUp = true
          } else {
            lineLength --;
          }
        }

        myLine.geometry.drawRange.count = lineLength;

        camera.projectionMatrix.fromArray(projectionMatrix);

        if (projection && projection.name === 'globe') {
          if (!plateCreated) {
            const target = new mapboxgl.LngLat(centerLatLng[0], centerLatLng[1]);

            const plate = target.toBounds(plateSize);


            const nw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthWest(), 0);
            const sw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getSouthWest(), 0);
            const ne_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthEast(), 0);
            const se_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getSouthEast(), 0);

            u.u_plate_tl_up.value.fromArray(plate.getNorthWest().toEcef(0));
            u.u_plate_br_up.value.fromArray(plate.getSouthWest().toEcef(0));
            u.u_plate_tr_up.value.fromArray(plate.getNorthEast().toEcef(0));
            u.u_plate_bl_up.value.fromArray(plate.getSouthEast().toEcef(0));

            u.u_plate_tl.value.fromArray([nw_merc.x, nw_merc.y, nw_merc.z]);
            u.u_plate_bl.value.fromArray([sw_merc.x, sw_merc.y, sw_merc.z]);
            u.u_plate_tr.value.fromArray([ne_merc.x, ne_merc.y, ne_merc.z]);
            u.u_plate_br.value.fromArray([se_merc.x, se_merc.y, se_merc.z]);

            u.u_plate_width.value = nw_merc.x - ne_merc.x;
            u.u_plate_height.value = sw_merc.y - nw_merc.y;

            u.u_scale_factor.value = getScalingFactor(anchor[1]);
            u.u_plate_up_scale.value = earthRadius;

            plateCreated = true;
          }
          u.u_zoom_transition.value = transition;
          u.u_matrix_globe_merc.value.fromArray(globeToMercMatrix);
          u.u_pixelsPerMeterRatio.value = pixelsPerMeterRatio;
          u.u_centerInMerc.value.fromArray(centerInMercator);
        } else {
          u.u_zoom_transition.value = 1;
        }
      }



      renderer.resetState();
      renderer.render(scene, camera);


      statsPanels.forEach(stats => stats.end());
  }

}

